// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__sanomatSans_4c24e4', '__sanomatSans_Fallback_4c24e4'"},"className":"__className_4c24e4","variable":"__variable_4c24e4"};